import { StyleSheet } from '@react-pdf/renderer';
// import { Font } from '@react-pdf/renderer';

// Font.register({
//   family: 'GenShinGothic',
//   fonts: [
//     {
//       src: 'https://cdn.jsdelivr.net/gh/qrac/genshin-fonts/GenShinGothic-P-Regular.ttf',
//       fontWeight: 400,
//     },
//     {
//       src: 'https://cdn.jsdelivr.net/gh/qrac/genshin-fonts/GenShinGothic-P-Bold.ttf',
//       fontWeight: 700,
//     },
//   ],
// });

// Font.register({
//   family: 'SourceHanSans',
//   src: 'https://cdn.jsdelivr.net/npm/@fontsource/source-han-sans-japanese/files/source-han-sans-japanese-all-400-normal.woff2',
// });


const styles = StyleSheet.create({
  header: {
    flexDirection: 'column', // ensures vertical stacking
    alignItems: 'left',
    justifyContent: 'flex-start'
  },
 footer: {
    position: 'absolute',
    bottom: 4,
    left: 12,
    right: 30,
    // flexDirection: 'column',
    // justifyContent: 'flex-start',
     flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: 0
  },
  
  footerText: {
    fontSize: 6,
    //color: '#333',
    marginBottom: 0,
     fontWeight: 'light', 
  },
  legendRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 1,
  },
  leftText: {
    flex: 1,
    fontSize: 7,
    
  },
   legendLeftText: {
    flex: 1,
    fontSize: 7,
     fontWeight: 'bold'
  },
  rightText: {
    flex: 1,
    fontSize: 7,
    textAlign: 'right',
  },
  footerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 6,
  },
  leftBlock: {
    flexDirection: 'column',
    width: '48%',
  },
  rightBlock: {
    flexDirection: 'column',
    width: '48%',
    alignItems: 'flex-end',
  },
logo: {
width: 120,
height: 30,
 },
 alignLeft: {
  textAlign: 'left',
  alignSelf: 'flex-start',
},
alignRight: {
  textAlign: 'right',
  alignSelf: 'flex-end',
},
footerLine: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginBottom: 2,
},footerFourColumn: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: 6
  
},footerColumn: {
  flexDirection: 'column',
  width: '19%'

},
footerText1: {
  fontSize: 7,
   //color: '#333',
  marginBottom: 6,
  display: 'block', // forces vertical stacking
},signatureImage: {
  width: 100,
  height: 40,
  marginBottom: 4,
},
footerColumn1: {
  flexDirection: 'column',
  width: '23%',
 alignItems: 'center'
},
footerText2: {
  fontSize: 8,
color: '#333',
  marginBottom: 2,
  textAlign: 'center',
   fontWeight: 'bold'
},
  leftText1: {
     
    flex: 1,
    fontSize: 6,
    color: '#333',
    display: 'block'
  },  rightText1: {
    
    flex: 1,
    fontSize: 5
    //textAlign: 'right',
  }, legendRow1: {
    flexDirection: 'row',
   color: '#333',
    marginVertical: 1,
  },leftWrapper: {
  width: '80%',
},
rightWrapper: {
  width: '20%',
  color: '#333',
},
//   companyText: {
//     fontSize: 5,
//     fontWeight: 'bold',
//     textAlign: 'left',
//     paddingTop:-8,
//   paddingLeft:4
//   }
 companyText: {
    fontSize: 6,
   // fontWeight: 'bold',
    textAlign: 'left',
    paddingTop: 0,
    paddingLeft: 0,
    lineHeight: 1.4,            
    color: '#333',              
    fontFamily: 'Helvetica',      
   
  }

,hedaerColumn1: {
  flexDirection: 'row',
  width: '70%',
 alignItems: 'left'},
hedaerColumn2: {
  flexDirection: 'row',
  width: '30%',
 alignItems: 'right',
alignSelf: 'flex-end'},
footereachpageColumn1:{
 flexDirection: 'column',
  width: '60%',
 alignItems: 'left'
},
footereachpageColumn2:{
  flexDirection: 'column',
  width: '40%',
 alignItems: 'right',
alignSelf: 'flex-end'
},
 headertext1: {
  fontSize: 9,
  color:  '#333',
  marginBottom: 6,
  display: 'block', // forces vertical stacking
  paddingTop: -10,
},
 headertextOfficial: {
  fontSize: 14,
   fontWeight: 'bold',
fontFamily: 'Times-Roman',
  color: '#333',
  marginBottom: 6,
  display: 'block', // forces vertical stacking
},
headertextOfficialColumn :{
  flexDirection: 'row',

},
headertextOfficialtext: {
  fontSize: 8,
   fontWeight: 'light',  
      
    paddingTop:6,
    color: '#333',
},
headerTwoColumn: {
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: 0
  
},page: {
    paddingTop: 9,
  //  paddingBottom: 60,
    //paddingHorizontal: 10,
    paddingLeft:12,
    paddingRight:25,
    //fontSize: 12,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #ccc',
    paddingVertical: 3,
    fontSize:8,
    height:47,
    alignItems:'center',
    
  },
  tableRow1: {
    flexDirection: 'row',
   // borderBottom: '1px solid #ccc',
    paddingVertical: 3,
    height:32,
alignItems:'center',
  backgroundColor: 'rgb(229, 228, 226)', 
    color: 'white', 

  },
   lastpagebar: {
    flexDirection: 'row',
   // borderBottom: '1px solid #ccc',
    paddingVertical: 3,
    height:20,
alignItems:'center',
  backgroundColor: 'rgb(229, 228, 226)', 
    color: 'black', 
justifyContent: "center"
  },
  lastpagebar1: {
   fontSize: 12,
    backgroundColor: '#d1c4c49c',
    

  },
  lastpagecontent:{
  flexDirection: 'row',
  fontSize: 10,
  },
  tableHeader: {
   fontSize: 8,
    backgroundColor: '#0a0a0a',
    

  },
  tableCell: {
    flex: 1,
    paddingHorizontal: 3,
  
  
  },
   completed: { flex: 9 },
  courseName: { flex: 36, 

  
  maxWidth: 200,
  wordBreak: 'break-word',
  wrap: true,
  },
   language: { flex: 9 },
  courseCode: { flex: 14 },
  program: { flex: 10 },
  hours: { flex: 6 },
  courseType: { flex: 13 ,     
     minWidth: 40,    
  maxWidth: 60,
   
},
  instructor: { flex: 10},

 link: {
    color: '#1a73e8',           // blue-ish
    textDecoration: 'underline', // underline the link
  }

});
export default styles;


